import loadScript from './load_script';

export const loadGeocoder = async (language) => {
  const apiKey = process.env.GOOGLE_API_KEY;

  return loadScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=${language}`);
}

export default loadGeocoder;



// WEBPACK FOOTER //
// ./src/utils/geocoder.js